<template>
	<div>
		<div class="p4">
			<core-select-binders v-model="binders" />
			<j-button
				v-if="binders && binders.length"
				class="mt4"
				:isLoading="isLoading"
				@click="addContract"
			>
				{{ $t("add") }}
			</j-button>
		</div>
	</div>
</template>

<script>
import CoreSelectBinders from "@/modules/core/components/CoreSelectBinders.vue"
import JButton from "@/components/JButton"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { CoreSelectBinders, JButton },
	data() {
		return { isLoading: false, binders: [] }
	},
	methods: {
		async addContract() {
			const query = gql`
				mutation addAssociatedContractToProposalOffer(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
					$associatedContractId: String!
				) {
					addAssociatedContractToProposalOffer(
						caseId: $caseId
						proposalId: $proposalId
						offerId: $offerId
						associatedContractId: $associatedContractId
					) {
						status
						errors
					}
				}
			`

			this.isLoading = true
			const res = await api({
				query,
				variables: {
					caseId: this.$store.state.caseManagement.caseId,
					proposalId: this.$store.state.caseManagement.proposalId,
					offerId: this.$store.state.caseManagement.offerId,
					associatedContractId: this.binders?.[0]?.id
				}
			})
			this.isLoading = false

			// Check errors
			if (
				res?.data?.addAssociatedContractToProposalOffer?.status !== "success"
			) {
				this.$store.dispatch(
					"showError",
					res?.data?.addAssociatedContractToProposalOffer?.errors?.[0] ||
						this.$t("errors.general")
				)
				return
			}

			this.$emit("contract:added")
		}
	}
}
</script>
